import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { RootState } from "../store";
import { PermissionEnum } from "../Components/constants/permissions";


export const usePermissions = (): PermissionEnum[] => {
  const getPermissionsFromStorage = (): PermissionEnum[] => {
    try {
      const authUser = sessionStorage.getItem("authUser");
      if (authUser) {
        const userData = JSON.parse(authUser);
        if (userData.permissions && Array.isArray(userData.permissions)) {
          const validPermissions = userData.permissions.filter((p: string) =>
            Object.values(PermissionEnum).includes(p as PermissionEnum)
          ) as PermissionEnum[];
          
          if (validPermissions.includes(PermissionEnum.ALL)) {
            return Object.values(PermissionEnum);
          }
          return validPermissions;
        }
      }
    } catch (error) {
      console.error("Error parsing permissions from sessionStorage:", error);
    }
    return [];
  };

  const selectLoginState = (state: RootState) => (state as any).Login;
  const loginSelector = createSelector(selectLoginState, (login) => ({
    permissions: login.permissions || [],
    useraccessrights: login.useraccessrights || {},
  }));

  const { permissions: reduxPermissions, useraccessrights } = useSelector(loginSelector);

  const getPermissionsFromRedux = (): PermissionEnum[] => {
    if (reduxPermissions && Array.isArray(reduxPermissions) && reduxPermissions.length > 0) {
      const permissionNames = reduxPermissions.map((p: any) => p.permissionname || p);
      const validPermissions = permissionNames.filter((p: string) =>
        Object.values(PermissionEnum).includes(p as PermissionEnum)
      ) as PermissionEnum[];
      
      if (validPermissions.includes(PermissionEnum.ALL)) {
        return Object.values(PermissionEnum);
      }
      return validPermissions;
    }
    return [];
  };

  const getPermissionsFromAccessRights = (): PermissionEnum[] => {
    if (!useraccessrights || !useraccessrights.permissions) return [];
    
    const permissions = useraccessrights.permissions;
    if (Array.isArray(permissions)) {
      const validPermissions = permissions.filter((p: string) =>
        Object.values(PermissionEnum).includes(p as PermissionEnum)
      ) as PermissionEnum[];
      
      if (validPermissions.includes(PermissionEnum.ALL)) {
        return Object.values(PermissionEnum);
      }
      return validPermissions;
    }
    return [];
  };

  const storagePermissions = getPermissionsFromStorage();
  if (storagePermissions.length > 0) {
    return storagePermissions;
  }

  const reduxPermissionsList = getPermissionsFromRedux();
  if (reduxPermissionsList.length > 0) {
    return reduxPermissionsList;
  }

  return getPermissionsFromAccessRights();
};
